import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  Grid,
  Button,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import SwipeableViews from "react-swipeable-views";
import Pagination from "../components/Pagination";
import { autoPlay } from "react-swipeable-views-utils";
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export default function JoinInfo() {
  return (
    <Box style={{ overflow: "hidden" }}>
      <Carousel />
      <JoinBar />
    </Box>
  );
}

function Carousel() {
  const useStyles = makeStyles((theme) => ({
    carouselImg: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  }));
  const classes = useStyles();

  const data = [
    "/assets/images/JoinInfo/carousel (1).png",
    "/assets/images/JoinInfo/carousel (2).png",
    "/assets/images/JoinInfo/carousel (3).png",
  ];
  const [imageIndex, setImageIndex] = useState(0);
  return (
    <Box position="relative">
      <AutoPlaySwipeableViews
        enableMouseEvents={true}
        index={imageIndex}
        onChangeIndex={setImageIndex}
      >
        {data.map((item) => {
          return (
            <Box style={{ height: `calc(100vh - 64px - 85px)` }}>
              <img src={item} className={classes.carouselImg} />
            </Box>
          );
        })}
      </AutoPlaySwipeableViews>
      <Pagination
        dots={data.length}
        index={imageIndex}
        onChangeIndex={setImageIndex}
      />
    </Box>
  );
}

function JoinBar() {
  const theme = useTheme();
  const history = useHistory();
  const isDownPc = useMediaQuery("(max-width:960px)");
  const joinMessage = [
    {
      message:
        "每月3000元起，領導品牌跟著走，身價大不同，富屋更讓您輕輕鬆鬆『圓一個大老闆的夢』！！！",
    },
    {
      message: "加盟專線：0800-800-680",
    },
  ];
  return (
    <div id="joinBar">
      <Box
        style={{
          backgroundColor: theme.palette.primary.main,
          padding: "1em",
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item xs={12} md={8}>
              <Box>
                {joinMessage.map((item) => {
                  return (
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      {item.message}
                    </Typography>
                  );
                })}
              </Box>
            </Grid>
            {/* 我要加盟btn */}
            <Grid
              container
              justify={isDownPc ? "center" : "flex-end"}
              item
              xs={12}
              md={4}
            >
              <Button
                size="big"
                variant="contained"
                onClick={() => history.push("/join")}
                style={{
                  borderRadius: "50px",
                  backgroundColor: theme.palette.secondary.light,
                  color: "#fff",
                  height: "50px",
                  width: isDownPc ? "300px" : "250px",
                }}
              >
                <Box px={2} my={4}>
                  我要加盟
                </Box>
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </div>
  );
}
